import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  public url: any[];
  public return: string;
  constructor(private router: Router) { 
    this.url = this.router.routerState.snapshot.url.split('/');
    this.return  = this.url[1];

  }

  ngOnInit() {
  }
  public go() {
    this.router.navigate([`/${this.return}`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/not-found/not-found.component.ts